
import { Component, Prop, Vue } from "vue-property-decorator";

@Component({
  components: {},
})
/** Tab strip; `v-model` (`value`) holds the selected tab's key. */
export default class Tabs extends Vue {
  @Prop({ required: true }) value!: string;
  /** @remarks Typed `string` but actually an array of `{ key, label }` — the prop type is wrong, not the usage. */
  @Prop({ required: true }) choices!: string;

  private select(key: number | string) {
    this.$emit("input", key);
  }
}
